import { Box } from '../../../imports/muiImport';
import christmasHeaderBell from '../../../assets/christmas_theme_assets/Header.png';
const DesktopHeaderBell = () => {
  return (
    <Box
      sx={{
        height: { md: 70, lg: 70, xl: 70 },
        width: "100%",
        zIndex: 9999,
        backgroundImage: `url(${christmasHeaderBell})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "white.main",
      }}
    />
  )
}

export default DesktopHeaderBell
